const contact = {
    readyFn: function () {
        let self = this;
        self.contactInit();
    },

    contactInit: function () {
        mapboxgl.accessToken = 'pk.eyJ1Ijoicmlva3kiLCJhIjoiY2t5OHU4Mjc1MDAwYTJvb3p0NnptMHVqbCJ9.EeY19Vp_POVeWFnufPw6_g';
        const map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/rioky/cky8uckh51y3716n2vlco45vo',
            center: [4.832851886749268, 47.02454376220703],
            zoom: 18,
            zoomwheel: false,
        });
        const geojson = {
            type: 'FeatureCollection',
            features: [{
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [4.832851886749268, 47.02454376220703]
                },
                properties: {
                    title: 'Mapbox',
                    description: 'Hotel Solstice'
                }
            },]
        };
        // disable map zoom when using scroll
        map.scrollZoom.disable();
        // Add zoom and rotation controls to the map.
        map.addControl(new mapboxgl.NavigationControl());
        // add markers to map
        for (const feature of geojson.features) {
            // create a HTML element for each feature
            const el = document.createElement('div');
            el.className = 'marker hotelSolstice';
            // make a marker for each feature and add to the map
            new mapboxgl.Marker(el).setLngLat(feature.geometry.coordinates).addTo(map);
        }
        $(".hotelSolstice").text("Hôtel Solstice");
    },

};

export { contact };